export default __webpack_public_path__ + "static/travel-85fe4f9a2f52583b84385196ea38e227.png";